import type { FreeSpinReplayV2, ReplayStepV2 } from '../replay/schema';
import type { ReplayPresentationStep } from '../rendering/types';
import type { ReplayHeaderView, ReplayListItemView } from '../ui/replay-dialog';

export function adaptStoredReplayStep(step: ReplayStepV2): ReplayPresentationStep {
  return Object.freeze({
    spinIndex: step.spinIndex,
    stops: step.stops,
    grid: step.grid,
    lineWins: step.lineWins,
    scatterCount: step.scatterCount,
    totalWinCents: step.spinWinCents,
    cumulativeWinCents: step.cumulativeWinCents,
    stickyBefore: step.stickyBefore,
    stickyAfter: step.stickyAfter,
    newlySticky: step.newlySticky,
    retriggerAwarded: step.retriggerAwarded,
    freeSpinsLeftAfter: step.freeSpinsLeftAfter,
    freeSpinsTotalAfter: step.freeSpinsTotalAfter,
    ...(step.potOfGreed === undefined ? {} : { potOfGreed: step.potOfGreed }),
    ...(step.godEvents === undefined ? {} : { godEvents: step.godEvents }),
  });
}

export function adaptReplayHeader(replay: FreeSpinReplayV2): ReplayHeaderView {
  return {
    name: replay.name,
    xValue: replay.betCents > 0 ? replay.totalWinCents / replay.betCents : 0,
    totalWinCents: replay.totalWinCents,
  };
}

export function adaptReplayListItem(replay: FreeSpinReplayV2): ReplayListItemView {
  return {
    id: replay.id,
    name: replay.name,
    xValue: replay.betCents > 0 ? replay.totalWinCents / replay.betCents : 0,
    createdAt: replay.createdAt,
  };
}
